import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { useAdmin } from "./AdminContext";

export function AdminLayout({ children }) {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-secondary/30">
      <header
        data-testid="admin-header"
        className="sticky top-0 z-40 border-b border-border bg-background/90 backdrop-blur"
      >
        <div className="container-wide flex items-center justify-between py-3">
          <div className="flex items-center gap-3">
            <Link to="/admin" className="flex items-center gap-2 text-sm font-medium text-foreground" data-testid="admin-home">
              <ShieldCheck className="h-4 w-4 text-accent" />
              <span className="tracking-tight">Tip Top — Admin</span>
            </Link>
            <span className="hidden md:inline text-xs text-muted-foreground">
              {admin?.email}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/" className="text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="admin-back-site">
              ← Naar site
            </Link>
            <button
              type="button"
              onClick={onLogout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-1.5 text-xs text-foreground/80 hover:text-accent transition-colors"
            >
              <LogOut className="h-3.5 w-3.5" />
              Uitloggen
            </button>
          </div>
        </div>
      </header>
      <main className="container-wide py-8">{children}</main>
    </div>
  );
}
